<template>
  <p class="text-yellow-400 px-10 font-bold text-justify text-xl tracking-wide mt-2 sm:text-3xl sm:mx-10 lg:text-2xl lg:mx-36 lg:text-left">
    <slot />
  </p>
</template>